import React, { useContext, useEffect, useState } from 'react';
import { Context_UI } from '../../Contexts/Context_UI';
import { useMapEditor } from '../../Contexts/Context_MapEditor';
import { useMapRenderer } from '../../Contexts/Context_MapRenderer';
import { useStatus } from '../../Contexts/Context_Status_Global';
import { useScheduleManagement } from '../../Contexts/Context_ScheduleManagement';
import UI_Card from '../ERUMAUI/UI_Card';
import UI_StatGroup from '../ERUMAUI/UI_StatGroup';
import UI_Button from '../ERUMAUI/UI_Button';
import UI_Icon from '../ERUMAUI/UI_Icons';
import { useNavigate } from 'react-router-dom';
import UI_Divider from '../ERUMAUI/UI_Divider';

export default function Panel_Map_Right() {
    const UI = useContext(Context_UI);
    const { Map_Information_Type, Map_Information, Map_Time_Parameters, Room_Get_Address } = useMapRenderer();
    const { Panel_Right_State, Panel_Toggle } = useStatus();
    const { Room_State_Get, Room_Schedules_Get, Room_Schedules_Current_Get, Time_Range_Parse, Time_Parse } = useScheduleManagement();

    const Navigate = useNavigate();

    const State_Get = (Type) => {
        if (!Map_Information._id) { return; }
        const State = Room_State_Get(Map_Information._id, Map_Time_Parameters.Date, Map_Time_Parameters.Time_Start, Map_Time_Parameters.Time_End);
        if (Type == "Color") {
            switch (State) {
                case "Available":
                    return "Green";
                case "Pending":
                    return "Orange";
                case "Occupied":
                    return "Red";
            }
        } else if (Type == "Text") {
            switch (State) {
                case "Available":
                    return "Available";
                case "Pending":
                    return "Activity pending approval";
                case "Occupied":
                    return "In use";
            }
        }
    }

    const [Room_BlockedHours, Room_BlockedHours_Set] = useState(null);
    const [Room_Airconditioner, Room_Airconditioner_Set] = useState(null);
    const [Room_Capacity, Room_Capacity_Set] = useState(null);

    useEffect(() => {
        if (Map_Information && Map_Information_Type === "Room" && Map_Information.Restrictions.hasBlockedHours) {
            const Day_Current = new Date(Map_Time_Parameters.Date).getDay();
            const Room_Restrictions = Map_Information.Restrictions.BlockedHours[Day_Current];

            if (Room_Restrictions.Block) {
                Room_BlockedHours_Set({
                    Start: Room_Restrictions.Start,
                    End: Room_Restrictions.End
                })
            } else {
                Room_BlockedHours_Set(null)
            }
        } else {
            Room_BlockedHours_Set(null);
        }
        if (Map_Information && Map_Information_Type === "Room" && Map_Information.Restrictions.hasAirconditioner) {
            Room_Airconditioner_Set(true);
        } else {
            Room_Airconditioner_Set(false);
        }
        if (Map_Information && Map_Information_Type === "Room" && Map_Information.Capacity) {
            Room_Capacity_Set(Map_Information.Capacity);
        } else {
            Room_Capacity_Set(false);
        }

    }, [Map_Information, Map_Time_Parameters]);


    return (
        <>
            {!Map_Information ?
                <p className="General_Paragraph">
                    Select a room marker, the directory, or the map controls to see the selection's information.
                </p>
                :
                <div style={{ display: "grid", gridTemplateRows: "auto auto auto auto auto 1fr auto", height: "-webkit-fill-available" }}>
                    <h1 className='General_Title' style={{ marginBottom: "5px" }}>
                        {Map_Information?.Name}
                    </h1>
                    <p className='General_Paragraph'>
                        {Map_Information_Type == "Room" ? Map_Information.Type : ""}
                    </p>
                    <p className='General_Paragraph'>
                        {Map_Information_Type == "Building" ? Map_Information.Address : ""}
                    </p>
                    {
                        Map_Information_Type === "Room" ?
                            <>
                                <UI_Divider />
                                <UI_StatGroup
                                    Items={[
                                        {
                                            Key: "Status",
                                            Value: State_Get("Text"),
                                            Color: State_Get("Color")
                                        },
                                        Room_Capacity ? {
                                            Key: "Capacity",
                                            Value: Room_Capacity,
                                            Color: "Gray"
                                        } : undefined,
                                        Room_Airconditioner ? {
                                            Key: "Airconditioning",
                                            Value: "Available",
                                            Color: "Green"
                                        } : {
                                            Key: "Airconditioning",
                                            Value: "Unavailable",
                                            Color: "Gray"
                                        },
                                        {
                                            Key: "Class hours",
                                            Value: Room_BlockedHours ? Time_Range_Parse(Room_BlockedHours.Start, Room_BlockedHours.End, "Time") : "None",
                                            Color: Room_BlockedHours ? "Orange" : "Green"
                                        }
                                    ]}
                                />
                            </>

                            :
                            ""
                    }

                    {Map_Information_Type == "Room" ?
                        <>
                            <div>
                                {Room_Schedules_Current_Get(Map_Information._id, Map_Time_Parameters.Date, Map_Time_Parameters.Time_Start, Map_Time_Parameters.Time_End).length > 0 ?
                                    <>
                                        <UI_Divider Text="Current activities" />
                                        {Room_Schedules_Current_Get(Map_Information._id, Map_Time_Parameters.Date, Map_Time_Parameters.Time_Start, Map_Time_Parameters.Time_End)?.map((Schedule) => (
                                            <>
                                                <UI_Card Type="Panel_Info_Inverted"
                                                    Text={Time_Range_Parse(Schedule?.Time.Start, Schedule?.Time.End)}
                                                    Figure={Schedule?.Name} />
                                            </>
                                        ))}
                                    </>
                                    :
                                    ""
                                }
                            </div>

                            <UI_Button
                                Text="Reserve this room"
                                Icon={<UI_Icon Name="Schedule" />}
                                Icon_Position="Left"
                                OnClick={() => Navigate(`/schedules/reserve?rm=${Map_Information._id}`)}
                            />

                        </>
                        :
                        ""
                    }

                </div>
            }
        </>


    );
}
